import { render } from "./InternalGroupingsView.vue?vue&type=template&id=5e0d02f5"
import script from "./InternalGroupingsView.vue?vue&type=script&lang=js"
export * from "./InternalGroupingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__